<template>
    <div class="table-responsive">
        <b-table
            v-if="items.length"
            :fields="fields"
            :items="items"
            responsive="sm"
            hover
        >
            <template #cell(selected)="data">
                <b-form-checkbox
                    v-model="data.item.selected"
                    name="check-button"
                    class="custom-control-success"
                    @change="(v) => onChange(v, data.item)"
                    switch
                    inline
                />
            </template>

            <template #cell(document)="data">
                {{ data.item.file.name }}
            </template>

            <template #cell(legislations)="data">
                <b-badge style="margin-right: 4px;" v-for="legislation in data.item.legislations">{{ legislation.title }}</b-badge>
            </template>

            <template #cell(document_type)="data">
                <b-badge style="margin-right: 4px;" v-for="type in data.item.documentTypes">{{ type.title }}</b-badge>
            </template>

            <template #cell(actions)="data">
                <div class="float-right" style="min-width: 106px;">
                    <Button
                        @click="download(data.item)"
                        class="b-icon btn-sm mr-1"
                    >
                        <b-spinner v-if="data.item.downloading" small />
                        <feather-icon
                            v-else
                            icon="DownloadCloudIcon"
                        />
                    </Button>
                    <Button
                        @click="preview(data.item)"
                        class="b-icon btn-sm"
                    >
                        <feather-icon
                            icon="EyeIcon"
                        />
                    </Button>
                </div>
            </template>
        </b-table>
        <div v-else>
            <b-alert
                class="ml-2 mr-2 mt-1"
                :variant="emptyMessageBg"
                show
            >
                <div class="alert-body">
                    There is no evidence reports
                </div>
            </b-alert>
        </div>
    </div>
</template>
<script>
import { BRow, BCol, BFormCheckbox, BTable, BBadge, BAlert, BSpinner } from 'bootstrap-vue'
import Button from "@core/components/common/Button.vue";
export default {
    components: {
        Button, BSpinner, BRow, BCol, BFormCheckbox, BTable, BBadge, BAlert
    },
    props: {
        documents: {
            required: true
        },
        selectable: {
            default: true
        },
        emptyMessageBg: {
            type: String,
            default: 'secondary'
        }
    },
    data() {
        const fields = [
            { key: 'selected', label: 'Select' },
            { key: 'document', label: 'Document' },
            { key: 'legislations', label: 'Legislations' },
            { key: 'document_type', label: 'Document type' },
            { key: 'actions', label: '' },
        ];

        if (!this.selectable) {
            fields.splice(0, 1);
        }

        return {
            fields: fields,
        }
    },
    methods: {
        onChange(value, evidenceReport) {
            this.$emit('input', value, evidenceReport);
        },
        download(document) {
            document.downloading = true;
            this.$emit('download', document, () => document.downloading = false);
        },
        preview(document) {
            this.$emit('preview', document);
        }
    },
    computed: {
        items() {
            let items = this.documents.filter(d => d.id)
            items.forEach((d) => {
                this.$set(d, 'downloading', false);
                if (!d.hasOwnProperty('selected')) {
                    d.selected = true;
                    this.$emit('input', true, d);
                }
            });

            return items;
        },
    }
}
</script>
